module.exports = __webpack_public_path__ + "static/img/IMG_20150306_145044.9ef76536.jpg";